import axios from 'axios';
import Vue from 'vue';
import {apiBaseUrl} from '@/store/config';

const CONFIG = (window as any).dlrhConfig;

export default {
  /* this request only is succeed locally if envUI is 'test' (src/public/assets/config.ts:1)
 * and forceProdMode is true (src/main.ts:53)
 */
  searchStaff(userId) {
    const url = `${apiBaseUrl}/staffsearch?searchstr=${userId}`;
    return axios.get(url, {
      headers: {
        'apikey': CONFIG.STAFF_API_APIKEY,
        'userId': CONFIG.STAFF_API_USERID
      }
    })
      .then((response) => {
        return response;
      })
      .catch(err => {
        console.error(err);
        throw new Error('It was not possible to display your search results.')
      })
  },
}
